[
  {
    "id": "chapter:6a",
    "q": "Regulatory signs are:",
    "answer": {
      "text": "White",
      "section": 6,
      "topic": "Regulatory Signs",
      "page": 39
    },
    "otherChoices": ["Green", "Yellow"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:6b",
    "q": "A yellow dashed line on your side of the roadway only means:",
    "answer": {
      "text": "Passing is permitted on your side",
      "section": 6,
      "topic": "Yellow Lane Markings",
      "page": 43
    },
    "otherChoices": ["Passing is prohibited on both sides", "Passing is permitted on both sides"],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "chapter:6c",
    "q": "When parking your vehicle facing uphill with a curb:",
    "answer": {
      "text": "Your wheels should be turned away from the curb",
      "section": 6,
      "topic": "Parking Uphill with a Curb",
      "page": 52
    },
    "otherChoices": ["Your wheels should be turned toward the curb", "Your wheels should face straight ahead"],
    "generated": null,
    "batch": "review-20260430",
    "version": 3,
    "updatedAt": "2026-04-30",
    "status": "discarded"
  },
  {
    "id": "chapter:6d",
    "q": "Turning on a steady green traffic light means that you:",
    "answer": {
      "text": "May turn but only when the intersection is clear to do so",
      "section": 6,
      "topic": "Traffic Signals",
      "page": 34
    },
    "otherChoices": [
      "Have the right-of-way from other users to complete the turn",
      "Should turn quickly before the light turns yellow or red"
    ],
    "generated": null,
    "batch": "baseline-chapter",
    "version": 2,
    "updatedAt": "2026-04-29",
    "status": "verified"
  },
  {
    "id": "sample:1",
    "q": "Which way should your wheels face when parking uphill with a curb?",
    "answer": {
      "text": "Away from the curb",
      "section": 6,
      "topic": "Parking Uphill with a Curb",
      "page": 52
    },
    "otherChoices": ["Towards the curb", "Straight forward"],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:1:derived:a",
    "q": "Which way should your wheels face when parking downhill with a curb?",
    "answer": {
      "text": "Towards the curb",
      "section": 6,
      "topic": "Parking Downhill with/without a Curb",
      "page": 52
    },
    "otherChoices": ["Away from the curb", "Straight forward"],
    "generated": {
      "parent": "sample:1",
      "type": "paired",
      "rationale": "Paired counterpart of sample:1. The handbook teaches uphill and downhill curbside parking in adjacent paragraphs on page 52. Uphill turns the wheels away from the curb, downhill turns them toward the curb so a rolling vehicle moves away from traffic. Distractors mirror sample:1 with the answer and inverted distractor swapped."
    },
    "batch": "review-20260502",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "sample:6",
    "q": "Lines separating driving lanes for traffic moving in opposite directions are:",
    "answer": {
      "text": "Yellow",
      "section": 6,
      "topic": "Pavement Markings",
      "page": 43
    },
    "otherChoices": ["White", "Blue"],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:6:derived:a",
    "q": "Lines separating driving lanes for traffic moving in the same direction are:",
    "answer": {
      "text": "White",
      "section": 6,
      "topic": "White Lane Markings",
      "page": 43
    },
    "otherChoices": ["Yellow", "Blue"],
    "generated": {
      "parent": "sample:6",
      "type": "paired",
      "rationale": "Paired counterpart of sample:6. The handbook teaches yellow markings for opposing traffic and white markings for same-direction traffic in adjacent paragraphs on page 43. Distractors mirror sample:6 with the colors swapped to reflect the answer."
    },
    "batch": "review-20260502",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "sample:8",
    "q": "At a 4-way stop:",
    "answer": {
      "text": "The driver reaching the intersection first should be given the right-of-way",
      "section": 6,
      "topic": "Right-of-Way",
      "page": 33
    },
    "otherChoices": [
      "The driver to the right should be given the right-of-way",
      "The driver to the left should be given the right-of-way"
    ],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:8:derived:a",
    "q": "At a 4-way stop, if more than one vehicle arrives at the same time:",
    "answer": {
      "text": "The vehicle on the right goes first",
      "section": 6,
      "topic": "Right-of-Way",
      "page": 33
    },
    "otherChoices": ["The vehicle on the left goes first", "The vehicle going straight has the right-of-way"],
    "generated": {
      "parent": "sample:8",
      "type": "paired",
      "rationale": "Paired counterpart of sample:8. The handbook teaches the simultaneous-arrival rule in the same paragraph as the first-arrival rule on page 33. Where sample:8 covers the typical case, this variant covers the tie-breaker. The 'going straight' distractor is drawn from the adjacent left-turn yielding rule on the same page."
    },
    "batch": "review-20260502",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "sample:13",
    "q": "What should you do if your vehicle stalls when crossing railroad tracks?",
    "answer": {
      "text": "Run in the direction from which the train is approaching",
      "section": 6,
      "topic": "Railroad Crossings",
      "page": 37
    },
    "otherChoices": [
      "Run across the tracks as far away as possible",
      "Run in the opposite direction from which the train is approaching"
    ],
    "generated": null,
    "batch": "baseline-sample",
    "version": 1,
    "updatedAt": "2026-04-20",
    "status": "verified"
  },
  {
    "id": "sample:13:derived:a",
    "q": "When you need to cross railroad tracks and no train is in sight:",
    "answer": {
      "text": "Look both ways and cross the tracks quickly, without stopping",
      "section": 6,
      "topic": "Railroad Crossings",
      "page": 37
    },
    "otherChoices": [
      "Stop on the tracks and check both ways before continuing",
      "Shift to a higher gear to cross more quickly"
    ],
    "generated": {
      "parent": "sample:13",
      "type": "paired",
      "rationale": "Paired counterpart of sample:13. The handbook teaches the routine no-train crossing rule alongside the stalled-vehicle rule on page 37. Where sample:13 covers the emergency, this variant covers the routine case. Distractors invert the handbook's explicit guidance against stopping on the tracks and against shifting gears mid-crossing."
    },
    "batch": "review-20260502",
    "version": 1,
    "updatedAt": "2026-05-02",
    "status": "verified"
  },
  {
    "id": "authored:s6-warning-sign-appearance",
    "q": "Warning signs are usually:",
    "answer": {
      "text": "Yellow with black lettering or symbols and are diamond shaped",
      "section": 6,
      "topic": "Warning Signs",
      "page": 35
    },
    "otherChoices": [
      "White with black, red or green letters and square or rectangular shaped",
      "Orange with black letters or symbols and diamond or rectangular shaped"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s6-school-bus-stop-exception",
    "q": "You must stop for a school bus that is stopped with its red lights flashing and/or stop arm extended, unless:",
    "answer": {
      "text": "It is traveling towards you and the roadway is separated by a median or other physical barrier",
      "section": 6,
      "topic": "Rules for School Buses",
      "page": 52
    },
    "otherChoices": [
      "There are two solid yellow lines between the lanes of traffic",
      "It is several lanes away on a wide, undivided road"
    ],
    "generated": null,
    "batch": "review-20260604",
    "version": 2,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s6-fire-hydrant-distance",
    "q": "You may not park within how many feet of a fire hydrant?",
    "answer": {
      "text": "15 ft.",
      "section": 6,
      "topic": "No-Parking Zones",
      "page": 54
    },
    "otherChoices": ["30 ft.", "50 ft."],
    "generated": null,
    "batch": "review-20260604",
    "version": 1,
    "updatedAt": "2026-06-04",
    "status": "verified"
  },
  {
    "id": "authored:s6-flashing-red-light",
    "q": "A flashing red traffic light means you must:",
    "answer": {
      "text": "Stop and use the same procedure as you would at a stop sign",
      "section": 6,
      "topic": "Traffic Signals",
      "page": 35
    },
    "otherChoices": [
      "Slow down and proceed with caution",
      "Prepare to stop because the light is about to change to red"
    ],
    "generated": null,
    "batch": "expansion-r1-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s6-stop-sign-shape",
    "q": "A stop sign:",
    "answer": {
      "text": "Has eight sides and is red with white letters",
      "section": 6,
      "topic": "Traffic Signs, Regulatory Signs",
      "page": 40
    },
    "otherChoices": [
      "Is a red and white downward pointing triangle with red letters",
      "Is diamond shaped and yellow with black lettering or symbols"
    ],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s6-reversible-lane-flashing-yellow-x",
    "q": "Signals above the lanes designate traffic flow in reversible lanes. A flashing yellow \"X\" means:",
    "answer": {
      "text": "The lane is for turning only",
      "section": 6,
      "topic": "Other Lane Controls, Reversible Lanes",
      "page": 45
    },
    "otherChoices": [
      "The lane is not available",
      "The use of the lane is changing and you should move out of it as soon as it is safe to do so"
    ],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 2,
    "updatedAt": "2026-07-30",
    "status": "verified"
  },
  {
    "id": "authored:s6-hov-lane-occupancy",
    "q": "On a roadway with reserved lanes, \"HOV 3\" means:",
    "answer": {
      "text": "There must be at least three people in the vehicle to use that lane",
      "section": 6,
      "topic": "Other Lane Controls, Reserved Lanes",
      "page": 45
    },
    "otherChoices": [
      "There must be less than three people in the vehicle to use that lane",
      "The lane is reserved for vehicles with three or more axles"
    ],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 2,
    "updatedAt": "2026-07-30",
    "status": "verified"
  },
  {
    "id": "authored:s6-turnabout-around-the-block",
    "q": "If you find yourself headed in the incorrect direction, the safest way to change direction is to:",
    "answer": {
      "text": "Turn right and go around the block",
      "section": 6,
      "topic": "General Rules, Turnabouts",
      "page": 47
    },
    "otherChoices": ["Perform a three-point turnabout", "Cross the median strip or use the crossover areas"],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 1,
    "updatedAt": "2026-07-29",
    "status": "verified"
  },
  {
    "id": "authored:s6-white-cane-right-of-way",
    "q": "Pedestrians using a guide dog or carrying a white cane:",
    "answer": {
      "text": "Must be given the right-of-way always",
      "section": 6,
      "topic": "Right-Of-Way",
      "page": 33
    },
    "otherChoices": [
      "Should be alerted with a light tap on the horn",
      "Can rely on the guide dog to wait until traffic has passed"
    ],
    "generated": null,
    "batch": "expansion-r2-20260729",
    "version": 2,
    "updatedAt": "2026-07-30",
    "status": "verified"
  },
  {
    "id": "authored:s6-green-arrow",
    "q": "A green arrow on a traffic signal means:",
    "answer": {
      "text": "You can safely turn in the direction of the arrow, if the intersection is clear of other roadway users",
      "section": 6,
      "topic": "Traffic Signals",
      "page": 34
    },
    "otherChoices": [
      "The green arrow is ending and you should prepare to stop and yield the right-of-way to oncoming traffic or pedestrians",
      "You must stop, and you may not go in the direction of the arrow until the green arrow or light returns"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s6-do-not-enter-sign",
    "q": "A square sign with a white horizontal line inside a red circle means:",
    "answer": {
      "text": "You cannot enter",
      "section": 6,
      "topic": "Regulatory Signs",
      "page": 41
    },
    "otherChoices": [
      "Your vehicle is moving in the wrong direction",
      "You are at the end of a no passing zone and may pass when it is safe to do so"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s6-right-turn-on-red",
    "q": "At a steady red traffic light, if there is no sign prohibiting a right turn on red, you may turn right:",
    "answer": {
      "text": "After stopping and checking for traffic and pedestrians",
      "section": 6,
      "topic": "Traffic Signals",
      "page": 34
    },
    "otherChoices": ["Only after the traffic signal turns green", "After slowing down and proceeding with caution"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s6-left-turn-on-red",
    "q": "Where permitted, you may turn left at a steady red traffic light when moving from:",
    "answer": {
      "text": "A one-way street onto another one-way street, or from a two-way street onto a one-way street",
      "section": 6,
      "topic": "Traffic Signals",
      "page": 34
    },
    "otherChoices": [
      "A one-way street onto a two-way street",
      "Any street, after stopping and checking for traffic and pedestrians"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s6-roundabout-yield",
    "q": "When entering a roundabout or traffic circle, you must:",
    "answer": {
      "text": "Yield to any traffic in the circle",
      "section": 6,
      "topic": "General Rules, Roundabouts and Traffic Circles",
      "page": 49
    },
    "otherChoices": [
      "Change lanes or pass other vehicles to reach your exit",
      "Drive alongside large vehicles, such as trucks and buses"
    ],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s6-backing-travel-lane",
    "q": "Backing a vehicle in a travel lane is:",
    "answer": {
      "text": "Illegal and unsafe, except to parallel park",
      "section": 6,
      "topic": "General Rules, General Driving",
      "page": 45
    },
    "otherChoices": ["Permitted if you miss a turn or exit", "Permitted on the shoulder of the road"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s6-blue-curb",
    "q": "A curb painted blue indicates:",
    "answer": {
      "text": "A handicap restriction",
      "section": 6,
      "topic": "Parking",
      "page": 55
    },
    "otherChoices": ["A loading zone or some other restriction", "Fire zone restrictions"],
    "generated": null,
    "batch": "expansion-r3-20260731",
    "version": 1,
    "updatedAt": "2026-07-31",
    "status": "verified"
  },
  {
    "id": "authored:s6-right-of-way-who-must-yield",
    "q": "The rules on who must yield the right-of-way:",
    "answer": {
      "text": "Tell who must wait in different traffic situations",
      "section": 6,
      "topic": "Right-Of-Way",
      "page": 33
    },
    "otherChoices": [
      "Apply only where signs or signals regulate traffic flow",
      "Excuse you from preventing a collision when another roadway user fails to yield"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s6-yield-sign-meaning",
    "q": "A yield sign means you must:",
    "answer": {
      "text": "Slow down and allow traffic that has the right-of-way to cross before entering",
      "section": 6,
      "topic": "Regulatory Signs, Yield Sign",
      "page": 40
    },
    "otherChoices": [
      "Come to a complete stop, look both ways, and yield the right-of-way before entering",
      "Prepare to stop because the traffic light is about to change to red"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-work-zone-sign-appearance",
    "q": "Work zone signs are generally:",
    "answer": {
      "text": "Diamond or rectangular shaped and orange with black letters or symbols",
      "section": 6,
      "topic": "Traffic Signs, Work Zone Signs",
      "page": 38
    },
    "otherChoices": [
      "Yellow with black lettering or symbols and diamond shaped",
      "Fluorescent pink with black lettering"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-shared-center-left-turn-lane",
    "q": "Vehicles traveling in either direction may use a shared center left turn lane:",
    "answer": {
      "text": "Only to make left turns",
      "section": 6,
      "topic": "Other Lane Controls, Shared Center Left Turn Lane",
      "page": 44
    },
    "otherChoices": ["For passing", "For through traffic"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-dashed-white-line",
    "q": "A dashed white line between lanes of traffic means:",
    "answer": {
      "text": "You may cross it to change lanes if a safe gap in traffic is available",
      "section": 6,
      "topic": "Pavement Markings, White Lane Markings",
      "page": 43
    },
    "otherChoices": [
      "You must stay within the lane unless a special situation requires a lane change",
      "You may pass if the dashed line is on your side"
    ],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-freight-train-stopping",
    "q": "Once it is set into emergency braking, a 100-car freight train traveling at 55 mph will need:",
    "answer": {
      "text": "More than a mile to stop",
      "section": 6,
      "topic": "Railroad Crossing Warning Signs",
      "page": 37
    },
    "otherChoices": ["About 400 feet to stop", "About 268 feet to stop"],
    "generated": null,
    "batch": "expansion-r4-20260801",
    "version": 2,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s6-flashing-yellow-light",
    "q": "A flashing yellow traffic light means:",
    "answer": {
      "text": "Slow down and proceed with caution",
      "section": 6,
      "topic": "Traffic Signals",
      "page": 34
    },
    "otherChoices": [
      "Stop and use the same procedure as you would at a stop sign",
      "The traffic light is about to change to red"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-white-curb",
    "q": "A curb painted white indicates:",
    "answer": {
      "text": "Only short stops are permitted",
      "section": 6,
      "topic": "Parking",
      "page": 55
    },
    "otherChoices": ["A handicap restriction", "Fire zone restrictions"],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-wrong-way-sign",
    "q": "The Wrong Way sign, seen on expressway ramps a short distance past the Do Not Enter sign, tells you:",
    "answer": {
      "text": "Your vehicle is moving in the wrong direction",
      "section": 6,
      "topic": "Regulatory Signs",
      "page": 41
    },
    "otherChoices": [
      "You cannot enter",
      "You are at the end of a no passing zone and may pass when it is safe to do so"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-three-lane-position",
    "q": "When driving on a road with three or more lanes traveling in the same direction:",
    "answer": {
      "text": "Use the center travel lane, especially when there is a lot of traffic entering or exiting the traffic flow",
      "section": 6,
      "topic": "General Rules",
      "page": 46
    },
    "otherChoices": [
      "Treat the center lane as reserved for left turning vehicles and do not use it for through traffic",
      "Use the left-most lane, which is intended for passing slower vehicles"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s6-roundabout-left-turn-signal",
    "q": "When you intend to turn left at a traffic circle or roundabout:",
    "answer": {
      "text": "Signal right to take the exit once you have traveled three quarters of the way around",
      "section": 6,
      "topic": "General Rules, Roundabouts and Traffic Circles",
      "page": 50
    },
    "otherChoices": [
      "Signal right while approaching and until you have exited",
      "No signal is needed while approaching or exiting"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 2,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s6-parking-uphill-no-curb",
    "q": "When parking your vehicle uphill where there is no curb:",
    "answer": {
      "text": "Turn the steering wheel sharply toward the edge of the road",
      "section": 6,
      "topic": "Parking, Parking Uphill Without a Curb",
      "page": 53
    },
    "otherChoices": [
      "Turn the steering wheel sharply away from the edge of the road",
      "Leave your wheels facing straight ahead"
    ],
    "generated": null,
    "batch": "expansion-r5-20260801",
    "version": 2,
    "updatedAt": "2026-08-02",
    "status": "verified"
  },
  {
    "id": "authored:s6-steady-yellow-light",
    "q": "A steady yellow traffic light means:",
    "answer": {
      "text": "The traffic light is about to change to red",
      "section": 6,
      "topic": "Traffic Signals",
      "page": 34
    },
    "otherChoices": ["Slow down and proceed with caution", "The green arrow is ending"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-yellow-curb",
    "q": "A curb painted yellow indicates:",
    "answer": {
      "text": "A loading zone or some other restriction",
      "section": 6,
      "topic": "Parking",
      "page": 55
    },
    "otherChoices": ["Only short stops are permitted", "Fire zone restrictions"],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-railroad-advance-warning",
    "q": "A round yellow sign with an \"X\" symbol and black \"RR\" letters, placed along the road prior to a highway-railroad grade crossing:",
    "answer": {
      "text": "Cautions you to slow down, look and listen for a train, and be prepared to stop if a train is approaching",
      "section": 6,
      "topic": "Railroad Crossing Warning Signs",
      "page": 36
    },
    "otherChoices": [
      "Marks the crossing itself, where you must remain behind the stop line while a train approaches",
      "Requires you to come to a complete stop before every crossing"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-two-point-turnabout",
    "q": "The safest way to perform a two-point turnabout is to:",
    "answer": {
      "text": "Back the vehicle into a driveway, which allows you to see traffic better when leaving",
      "section": 6,
      "topic": "General Rules, Two-point Turnabout",
      "page": 48
    },
    "otherChoices": [
      "Pull forward into a driveway and back out into the street",
      "Use it on a multi-lane roadway whenever traffic is heavy"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 1,
    "updatedAt": "2026-08-01",
    "status": "verified"
  },
  {
    "id": "authored:s6-stop-line-first",
    "q": "When required to stop because of a sign or signal, and there is a stop line before the crosswalk, you should stop:",
    "answer": {
      "text": "Behind the stop line",
      "section": 6,
      "topic": "Pavement Markings, Crosswalks and Stop Lines",
      "page": 44
    },
    "otherChoices": [
      "Between the stop line and the crosswalk",
      "At the near edge of the crosswalk, if a pedestrian is waiting to cross"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 3,
    "updatedAt": "2026-08-03",
    "status": "verified"
  },
  {
    "id": "authored:s6-do-not-block-intersection",
    "q": "You may not enter an intersection unless you can get through it without blocking traffic flow. Before entering, you should:",
    "answer": {
      "text": "Wait until traffic ahead clears",
      "section": 6,
      "topic": "Right-Of-Way",
      "page": 34
    },
    "otherChoices": [
      "Wait for the light to turn yellow, then enter",
      "Enter as soon as the vehicle ahead begins to move"
    ],
    "generated": null,
    "batch": "expansion-r6-20260801",
    "version": 4,
    "updatedAt": "2026-08-03",
    "status": "verified"
  }
]
